/**
 * Class representing a command response on the Unified Login Component API
 */
export class CommandResponse{
    /**
     * @param {string} response
     * @param {object} responseDetails
     */

    constructor(response, responseDetails){
        this.response = response;
        this.responseDetails = responseDetails;
    }
}
